import { render } from "./Embed.vue?vue&type=template&id=310b5456"
import script from "./Embed.vue?vue&type=script&lang=js"
export * from "./Embed.vue?vue&type=script&lang=js"
script.render = render

export default script